import { GET_CHART_DETAIL } from '../Actions/actionTypes';
const initial = {

};
export default (state=initial,action)=>{
  switch(action.type){
    case GET_CHART_DETAIL:
      return action.payload;
    default:
      return state;
  }
}